import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { PATHS } from "@/routes/paths";
export function AdminGuard() {
    const { user, loading } = useAuth();
    if (loading) {
        return null;
    }
    if (!user || user.role !== "admin") {
        return _jsx(Navigate, { to: PATHS.TICKETS, replace: true });
    }
    return _jsx(Outlet, {});
}
